<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}
        </div>
        <div class="info_text mb20">
            배너 이미지는 640 X 160 사이즈에 최적화 되어 있습니다. <br>
            저장 버튼을 눌러야 해당 항목이 반영됩니다. <br>
        </div>
          <banner-image-list-component :banner-type="'liveclass'"></banner-image-list-component>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
      <image-banner-update-modal></image-banner-update-modal>
  </div>
</template>

<script>
import BannerImageListComponent from "@/components/banner/BannerImageListComponent.vue";
import ImageBannerUpdateModal from "@/components/modal/ImageBannerUpdateModal.vue";

export default {
  name: "LiveclassBanner",
  mixins: [],
  components: { BannerImageListComponent, ImageBannerUpdateModal },
  provide() {
    return {};
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
  },
  watch: {},
};
</script>
